const replaceParameters = (value, parameters) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const param of Object.keys(parameters)) {
    value = value.replace('{'.concat(param).concat('}'), parameters[param]);
  }
  return value;
};

export default replaceParameters;
